/* eslint-disable jsx-a11y/no-redundant-roles */

/**
 * ProgressIndicator.jsx
 * Created by Destin Frasier on 7/07/17.
 * Enhanced by Betty Huang on 8/15/17.
 */

import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    steps: PropTypes.arrayOf(PropTypes.string).isRequired,
    activeStep: PropTypes.number
};

const defaultProps = {
    activeStep: 0
};

export default class ProgressIndicator extends React.Component {
    renderSteps() {
        // While we allow developers to pass in the actual, 1-indexed step, we will use
        // an internal 0-indexed step
        const trueStep = this.props.activeStep < 1 ? 0 : this.props.activeStep - 1;

        const steps = [];

        for (let i = 0; i < this.props.steps.length; i++) {
            if (i < trueStep) {
                steps.push(
                    <li key={i} id={`progress-step-${i}`}>
                        <div className="rec-progress-item rec-complete">
                            <div className="rec-bubble" />
                            <div aria-hidden="true" className="rec-progress-step-text">{this.props.steps[i]}</div>
                            <span className="rec-sr-only">{`You have completed ${this.props.steps[i]}`}</span>
                        </div>
                    </li>
                );
            }
            else if (i === trueStep) {
                steps.push(
                    <li key={i} id={`progress-step-${i}`}>
                        <div className="rec-progress-item rec-complete rec-current">
                            <div className="rec-bubble" />
                            <div aria-hidden="true" className="rec-progress-step-text">{this.props.steps[i]}</div>
                            <span className="rec-sr-only">{`You are currently on ${this.props.steps[i]}`}</span>
                        </div>
                    </li>
                );
            }
            else {
                steps.push(
                    <li key={i} id={`progress-step-${i}`}>
                        <div className="rec-progress-item">
                            <div className="rec-bubble" />
                            <div className="rec-progress-step-text">{this.props.steps[i]}</div>
                            <span className="rec-sr-only">{`You will proceed to ${this.props.steps[i]}`}</span>
                        </div>
                    </li>
                );
            }
        }

        return steps;
    }

    render() {
        return (
            <ol className="rec-progress-bar" role="list" aria-label="Transaction progress">
                {this.renderSteps()}
            </ol>
        );
    }
}

ProgressIndicator.propTypes = propTypes;
ProgressIndicator.defaultProps = defaultProps;
